import AttributeModel, { SelectedAttributeModel } from '@/models/AttributeModel';
import VehicleDetail, { YearModel } from './VehicleDetail';
import { AttributeTypes } from '@/common/enum';

export default class OrderDetailModel {
    public id?: number;
    public retailerId?: number;
    public storeId?: number;
    public regNo?: string;
    public createdAt?: string;
    public isOrdered: boolean = false;
    public communication?: CommunicationModel;
    public vehicle: VehicleModel = {} as VehicleModel;
    public attributes: AttributeModel[] = [];
    public configuration: ConfigurationModel = {} as ConfigurationModel;

    public get toVehicleDetail(): VehicleDetail {
        const vehicleDetail = new VehicleDetail();
        vehicleDetail.regNo = this.regNo;
        vehicleDetail.make = this.vehicle.make;
        vehicleDetail.modelGroup = this.vehicle.modelGroup;
        vehicleDetail.model = this.vehicle.model;
        vehicleDetail.doors = this.vehicle.doors;
        vehicleDetail.transmission = this.vehicle.transmission;
        vehicleDetail.yearModel = new YearModel();
        vehicleDetail.yearModel.generation = this.vehicle.generation;
        vehicleDetail.yearModel.startYear = this.vehicle.startYear;
        vehicleDetail.yearModel.endYear = this.vehicle.endYear;
        vehicleDetail.yearModel.range = this.vehicle.range;
        vehicleDetail.imageURL = this.vehicle.vehicleImage;

        return vehicleDetail;
    }

    public get toSelectedAttributeModel(): SelectedAttributeModel[] {
        let attributes: SelectedAttributeModel[] = [];
        attributes = this.attributes.map((attribute) => {
            const attr = new SelectedAttributeModel();
            Object.assign(attr, attribute);
            attr.title = AttributeTypes[attribute.type]
                .replace(/([A-Z]+)/g, ' $1')
                .replace(/([A-Z][a-z])/g, ' $1')
                .trim();
            return attr;
        });
        return attributes;
    }
}

export interface CommunicationModel {
    email: string;
    phone: string;
}

export interface VehicleModel {
    make: string;
    modelGroup: string;
    model: string;
    doors: number;
    transmission: string;
    generation: string;
    startYear: number;
    endYear: number;
    range: string;
    vehicleImage: string;
}

export interface ConfigurationModel {
    configLinkBase: string;
    price: string;
    shopName: string;
    headerLogo: string;
    footerLogo: string;
    footerName: string;
    footerEmail: string;
    footerPhone: string;
}
